import React from 'react';
import HeadersNonAuth from '../../../components/base/HeadersNonAuth';

const ThankYou = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans min-h-screen mt-10">
      <HeadersNonAuth />
      <br />
      <br />

    <section id="thankyou" className="bg-[#0b0d2a] text-white px-6 lg:px-24 py-16 font-sans">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <h2 className="text-3xl sm:text-4xl font-bold mb-8">
            Thank - You
        </h2>

        <p className="mb-4">
             Thank you for subscribing!
        </p>
         <p className="mb-4">
             Check your inbox — your free access is on its way.
        </p>
      </div>
    </section>
    </div>
  );
};

export default ThankYou;
